import { IResourceConfig } from "@/constants/resources";
import { actionVerb, countLabel } from "@/helpers/ResourceHelpers";
import { FC } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const NAMES_SHOWN = 5;

interface IProps {
  show: boolean;
  config: IResourceConfig;
  count: number;
  //* Noms des lignes sélectionnées, quand le tableau en fournit
  names: string[];
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const BulkDeleteConfirmModal: FC<IProps> = ({
  show,
  config,
  count,
  names,
  isSubmitting,
  onConfirm,
  onCancel,
}) => {
  const action = `${actionVerb(config)} ${countLabel(config, count)}`;
  const shown = names.slice(0, NAMES_SHOWN);
  const others = count - shown.length;

  return (
    <Modal
      show={show}
      onHide={isSubmitting ? undefined : onCancel}
      centered
      className="formalys-modal"
      aria-labelledby="bulk-delete-title"
    >
      <Modal.Header closeButton={!isSubmitting}>
        <Modal.Title id="bulk-delete-title">{action} ?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {shown.length > 0 && (
          <p className="mb-2">
            {shown.join(", ")}
            {others > 0 && `, et ${others} ${others > 1 ? "autres" : "autre"}`}
          </p>
        )}
        <p className="mb-0">
          {config.effect === "archive"
            ? "Les fiches restent consultables dans les archives."
            : "Cette action est irréversible."}
        </p>
        {config.warning && (
          <p className="mb-0 mt-2 text-danger fw-semi-bold">{config.warning}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="nolina-default"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Annuler
        </Button>
        <Button
          variant={config.effect === "archive" ? "primary" : "danger"}
          onClick={onConfirm}
          disabled={isSubmitting}
          aria-label={action}
        >
          {isSubmitting ? <Spinner animation="border" size="sm" /> : action}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BulkDeleteConfirmModal;
